import owd from 'owd/owd';
import Modal from './modal';

export default class ModalInfo extends Modal {
  init() {
    this.sessionName = 'popup-info-womad';
    this.close = this.$element.find('.modal-button');

    super.init();
    this.bind();
  }

  setSession() {
    sessionStorage.setItem(this.sessionName, 1);
  }

  bind() {
    super.bind();

    this.on('load ajaxload', this.dom.$window, () => {
      if(sessionStorage.getItem(this.sessionName) === null) {
          this.$element.trigger('show');
      } else {
        this.$element.trigger('hide');
      }
    });

    this.on('click', this.closeButton, () => {
      this.setSession();
    });

    this.on('click', this.close, () => {
      this.setSession();
      this.$element.trigger('hide');
    });

    this.on('click', this.dom.$body, '[data-modal-open=".modal--info"]', () => {
      this.$element.trigger('show');
    });

    // this.on('load ajaxload resize', this.dom.$window, () => {
    //     if (window.innerWidth < 1200) {
    //         this.on('click', this.dom.$body, () => {
    //             this.$element.addClass('is-hidden');
    //             this.setCookie();
    //         });
    //         this.on('scroll', this.dom.$window, () => {
    //             this.$element.addClass('is-hidden');
    //             this.setCookie();
    //         });
    //     }
    // })
  }
}

owd.registerComponent('modal-info', {
  component: ModalInfo
});
